/**
 * Whether this device's link is good enough to sync a big file (WS2): the Network Information API
 * (Chromium only) as ER1's candidate report reads it. Without the API the link counts as good.
 */

/** The fields of `navigator.connection` the rule reads. */
export interface LinkInfo {
  type?: string;
  effectiveType?: string;
  saveData?: boolean;
}

/** Not on Save-Data, not cellular or offline, and 4g or faster (or not reported). */
export function isGoodLink(link: LinkInfo | null | undefined): boolean {
  if (!link) return true;
  if (link.saveData || link.type === "cellular" || link.type === "none") return false;
  return !link.effectiveType || link.effectiveType === "4g";
}

export function browserLinkIsGood(): boolean {
  return isGoodLink((globalThis.navigator as { connection?: LinkInfo } | undefined)?.connection);
}

/** Calls `listener` when the browser's link changes (Network Information API); returns the unsubscribe. */
export function onBrowserLinkChange(listener: () => void): () => void {
  const connection = (globalThis.navigator as { connection?: EventTarget } | undefined)?.connection;
  if (typeof connection?.addEventListener !== "function") return () => undefined;
  connection.addEventListener("change", listener);
  return () => connection.removeEventListener("change", listener);
}
